import User from '../api/User';
import { getToken, saveToken } from '../utils';


const currentUser = new User({});


export const logout = async () => {
  await User.ajaxRequest('post', '/logout/')
};


export const reloadCurrentUser = async () => {
  const response = await User.ajaxRequest('get', '/current/');
  currentUser.setData(response.data);
  if (currentUser.is_active && getToken() === null) {
    const token = (
      await User.ajaxRequest('post', '/login_sso/')
    ).data.token;
    saveToken(token);
  }
};


reloadCurrentUser();


export default currentUser;
